import { render, staticRenderFns } from "./motorForm.vue?vue&type=template&id=516708c4&scoped=true&"
import script from "./motorForm.vue?vue&type=script&lang=js&"
export * from "./motorForm.vue?vue&type=script&lang=js&"
import style0 from "./motorForm.vue?vue&type=style&index=0&id=516708c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516708c4",
  null
  
)

export default component.exports